var React = require('react');

function IconEmptyFolder (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M0 96C0 60.7 28.7 32 64 32H196.1c19.1 0 37.4 7.6 50.9 21.1L289.9 96H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16H286.6c-10.6 0-20.8-4.2-28.3-11.7L213.1 87c-4.5-4.5-10.6-7-17-7H64z"}));
}

IconEmptyFolder.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = IconEmptyFolder;

IconEmptyFolder.default = IconEmptyFolder;
